import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// CONSTANTS
import { appVersion } from '@/constants/common';

// UTILITY
import { semverGreaterThan } from '@/utility/common';
import bugsnag from '@/utility/bugsnagClient';

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        if (window.caches) {
          // Service worker cache should be cleared with window.caches.delete()
          window.caches.keys().then(names => {
            for (const name of names) window.caches.delete(name);
          });
        }

        // delete browser cache and hard reload
        window.location.reload(true);
      },
    };
  }

  async componentDidMount() {
    try {
      await axios
        .get(`${window.location.origin}/meta.json`)
        .then(response => response.data)
        .then(meta => {
          const latestVersion = meta.version;
          const currentVersion = appVersion;

          const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

          if (shouldForceRefresh) {
            this.setState({ loading: false, isLatestVersion: false });
          } else {
            // eslint-disable-next-line no-console
            console.log(
              `You already have the latest version - ${latestVersion}. No cache refresh needed.`,
            );
            this.setState({ loading: false, isLatestVersion: true });
          }
        });
    } catch (e) {
      bugsnag.notify(new Error(`meta - error--${JSON.stringify(e)}`));
      throw new Error(e);
    }
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    const { children } = this.props;

    return children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}

CacheBuster.propTypes = {
  children: PropTypes.func,
};

export default CacheBuster;
